import { site, whatsappMessages } from "@/config/site";
import { trackEvent, EVENTS } from "@/lib/analytics";

// Builds a WhatsApp click-to-chat URL from the CENTRAL config number.
export function whatsappUrl(context = "general") {
  const msg = whatsappMessages[context] || whatsappMessages.general;
  return `https://wa.me/${site.whatsappNumber}?text=${encodeURIComponent(msg)}`;
}

export function openWhatsApp(context = "general") {
  trackEvent(EVENTS.WHATSAPP_CLICK, { context });
  window.open(whatsappUrl(context), "_blank", "noopener,noreferrer");
}

export function telUrl() {
  return `tel:${site.phoneE164}`;
}

export function trackPhoneClick() {
  trackEvent(EVENTS.PHONE_CLICK, {});
}
